export interface WebsiteRequestError {
  detail: string
  status: number
  title: number
  type: string
  violations: Record<string, string[]>
}

export class BaseError extends Error {
  public response: WebsiteRequestError

  constructor(response: WebsiteRequestError) {
    super()
    this.name = this.constructor.name
    this.response = response
  }
}
